import React from 'react';
import Modal from 'react-bootstrap/lib/Modal';
import Button from 'react-bootstrap/lib/Button';
import Dialog from 'components/Dialog';
import { shopifyService } from 'services';
import moment from 'moment';

const PAGE_SIZE = 20;

class DeliveryFailuresDialog extends Dialog {
    constructor(props) {
        super(props);
        this.state = Object.assign({}, this.state, {
            items: [],
            total: 0,
            offset: 0,
            loading: false,
            redelivering: false,
            result: null
        });
    }

    show() {
        this.setState({ offset: 0, items: [], total: 0, result: null }, () => {
            super.show();
            this.fetchPage(0);
        });
    }

    fetchPage(offset) {
        this.setState({ loading: true });
        shopifyService().deliveryFailures({ offset, limit: PAGE_SIZE }).then((response) => {
            const data = response.data || {};
            this.setState({ items: data.items || [], total: data.total || 0, offset: data.offset || offset, loading: false });
        }).catch(() => {
            this.setState({ loading: false });
        });
    }

    redeliverAll() {
        this.setState({ redelivering: true });
        shopifyService().redeliverFailures().then((response) => {
            const data = response.data || {};
            this.setState({
                redelivering: false,
                result: { queued: data.queued || 0, failed: data.failed || 0, capped: data.capped }
            });
            this.fetchPage(0);
            if (this.props.onRedelivered) this.props.onRedelivered();
        }).catch(() => {
            this.setState({ redelivering: false });
        });
    }

    render() {
        const { intl } = this.props;
        const t = id => intl.formatMessage({ id });
        const { items, total, offset, loading, redelivering, result } = this.state;
        const page = Math.floor(offset / PAGE_SIZE) + 1;
        const pages = Math.max(Math.ceil(total / PAGE_SIZE), 1);
        const hasPrev = offset > 0;
        const hasNext = offset + items.length < total;

        return (
            <Modal show={this.state.show} onHide={this.hide} bsSize="large">
                <Modal.Header closeButton>
                    <Modal.Title>{t('orderList.deliveryFailed')} ({total})</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {result &&
                        <div className="alert alert-info" style={{ marginBottom: '10px' }}>
                            {`${result.queued} redelivery request(s) queued${result.failed ? `, ${result.failed} failed` : ''}${result.capped ? ', capped at 100' : ''}`}
                        </div>
                    }
                    <table className="table table-condensed table-hover" style={{ marginBottom: '10px' }}>
                        <thead>
                            <tr>
                                <th style={{ width: '160px' }}>Order ID</th>
                                <th style={{ width: '110px' }}>{t('orderList.invoiceNum')}</th>
                                <th style={{ width: '130px' }}>{t('orderList.delivered')}</th>
                                <th>Reason</th>
                            </tr>
                        </thead>
                        <tbody>
                            {loading &&
                                <tr>
                                    <td colSpan="4" style={{ textAlign: 'center' }}>
                                        <i className="fa fa-spin fa-circle-o-notch" />
                                    </td>
                                </tr>
                            }
                            {!loading && items.length === 0 &&
                                <tr>
                                    <td colSpan="4" style={{ textAlign: 'center', color: '#999' }}>{t('orderList.noOrders')}</td>
                                </tr>
                            }
                            {!loading && items.map((item, i) => {
                                const reason = item.reason || (item.failed_channels && item.failed_channels.length ? `Failed channels: ${item.failed_channels.join(', ')}` : t('orderList.unknown'));
                                const status = item.delivered === false
                                    ? <span className="label label-danger">{t('orderList.notDelivered')}</span>
                                    : <span className="label label-warning">{t('orderList.deliveryPartial')}</span>;
                                return (
                                    <tr key={item.order_id || i}>
                                        <td>{item.order_id}</td>
                                        <td>{item.invoice_number ? `#${item.invoice_number}` : ''}</td>
                                        <td>{status}</td>
                                        <td>{reason}{item.delivered_at ? ` — ${moment(item.delivered_at).format('MM/DD/YYYY h:mm A')}` : ''}</td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        <span style={{ fontSize: '12px', color: '#64748b' }}>Page {page} / {pages}</span>
                        <div>
                            <Button bsSize="small" disabled={!hasPrev || loading} onClick={() => this.fetchPage(offset - PAGE_SIZE)}>{'<'} Prev</Button>{' '}
                            <Button bsSize="small" disabled={!hasNext || loading} onClick={() => this.fetchPage(offset + PAGE_SIZE)}>Next {'>'}</Button>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button bsStyle="primary" disabled={redelivering || total === 0} onClick={() => this.redeliverAll()}>
                        {redelivering ? <i className="fa fa-spin fa-circle-o-notch" /> : <i className="fa fa-paper-plane" />} Redeliver All
                    </Button>
                    <Button onClick={this.hide}>{t('orderList.close')}</Button>
                </Modal.Footer>
            </Modal>
        );
    }
}

export default DeliveryFailuresDialog;



// WEBPACK FOOTER //
// app/components/dashboard/DeliveryFailuresDialog.jsx